export enum RoleEnum {
    _None = 0,
    Administrator = 1,
    User = 2,
}